<template>
    <q-dialog v-model="showModal" persistent>
        <q-card style="max-width: 350px;" class="full-width">
            <q-card-section>
                <div class="text-h6 row items-center">
                    <q-icon name="mdi-lock-reset" size="sm" class="q-mr-xs" />Change Password
                    <q-space />
                    <q-btn icon="mdi-close" flat round dense v-close-popup />
                </div>
            </q-card-section>

            <q-card-section class="q-pt-none">
                <q-form @submit="onSubmit"
                        @reset="onReset"
                        autocomplete="off"
                        class="q-col-gutter-md">
                    <q-banner v-if="showError" rounded class="text-white bg-negative">
                        <q-icon name="mdi-alert" size="sm" color="white" class="q-mr-xs" />
                        {{ errorMessage }}
                    </q-banner>
                    <q-input outlined dense
                             :type="isOldPwd ? 'password' : 'text'"
                             label="Old Password" stack-label
                             autocomplete="current-password" name="password"
                             v-model="oldPassword"
                             :rules="[ val => $v.oldPassword.required || 'Old password is required', val => $v.oldPassword.minLength]"
                             hide-bottom-space>
                        <template v-slot:append>
                            <q-icon :name="isOldPwd ? 'mdi-eye-off' : 'mdi-eye'"
                                    class="cursor-pointer"
                                    color="grey-6" size="0.9em"
                                    @click="isOldPwd = !isOldPwd" />
                        </template>
                    </q-input>
                    <q-input outlined dense
                             :type="isPwd ? 'password' : 'text'"
                             label="New Password" stack-label
                             autocomplete="new-password" name="password"
                             v-model="password"
                             :rules="[ val => $v.password.required || 'Password is required', val => $v.password.minLength || `Password must have at least ${$v.password.$params.minLength.min} letters`]"
                             hide-bottom-space>
                        <template v-slot:append>
                            <q-icon :name="isPwd ? 'mdi-eye-off' : 'mdi-eye'"
                                    class="cursor-pointer"
                                    color="grey-6" size="0.9em"
                                    @click="isPwd = !isPwd" />
                        </template>
                    </q-input>

                    <q-input outlined dense
                             :type="isPwdConfirm ? 'password' : 'text'"
                             label="Confirm Password" stack-label
                             autocomplete="new-password" name="password"
                             v-model="confirmPassword"
                             :rules="[ val => $v.confirmPassword.sameAsPassword || 'Confirmation password does not match' ]"
                             hide-bottom-space>
                        <template v-slot:append>
                            <q-icon :name="isPwdConfirm ? 'mdi-eye-off' : 'mdi-eye'"
                                    class="cursor-pointer"
                                    color="grey-6" size="0.9em"
                                    @click="isPwdConfirm = !isPwdConfirm" />
                        </template>
                    </q-input>
                    <div class="row q-col-gutter-sm">
                        <div class="col-xs-12 col-sm-auto">
                            <q-btn :label="changePasswordPending ? 'Changing...' : 'Change Password'" type="submit" color="primary" class="full-width" />
                        </div>
                        <div class="col-xs-12 col-sm-auto">
                            <q-btn label="Cancel" type="reset" color="primary" flat class="full-width" v-close-popup />
                        </div>
                    </div>
                </q-form>
            </q-card-section>

            <q-inner-loading :showing="changePasswordPending">
                <div>
                    <q-spinner color="primary"
                               :thickness="2"
                               size="3em" />
                </div>
            </q-inner-loading>
        </q-card>
    </q-dialog>
</template>
<script>
    import { required, minLength, sameAs } from 'vuelidate/lib/validators'
    import { mapState } from 'vuex'

    export default {
        name: 'dialog-change-password',
        props: {
            id: String,
            show: {
                type: Boolean,
                default: false
            }
        },

        data() {
            return {
                showError: false,
                errorMessage: '',
                isOldPwd: true,
                isPwd: true,
                isPwdConfirm: true,
                oldPassword: '',
                password: '',
                confirmPassword: '',
            }
        },
        validations: {
            oldPassword: {
                required,
            },
            password: {
                required,
                minLength: minLength(8)
            },
            confirmPassword: {
                sameAsPassword: sameAs('password')
            }
        },
        methods: {
            resetPassword() {

                const payload = { id: this.id, oldPassword: this.oldPassword, newPassword: this.password, confirmPassword: this.confirmPassword }
                this.$store.dispatch('changePassword', payload).then(() => {
                    this.onReset()
                    this.showModal = false
                    this.$q.notify({
                        badgeClass: 'hidden',
                        type: 'positive',
                        message: 'Password has been updated'
                    })
                }).catch(err => {
                    this.errorMessage = err
                    this.showError = true
                })
            },

            onSubmit() {
                this.$v.$touch()
                if (this.$v.$pending || this.$v.$error) return
                this.resetPassword()
            },

            onReset() {
                this.oldPassword = ''
                this.password = ''
                this.confirmPassword = ''
                this.showError = false
            }
        },
        computed: {
            ...mapState([
                'changePasswordPending',
                'changePasswordData',
            ]),
            showModal: {
                get() {
                    return this.show
                },
                set(value) {
                    this.$emit('update:show', value)
                }
            },
        },
        created() {
            this.onReset()
        }

    }
</script>
